import { WidgetType } from '../../WidgetType.ts';
import { Reducer } from 'redux';
import { WidgetSetSharedConfigAction } from './actions.ts';
import { WidgetActionType } from '../actions.ts';

export function createSharedConfigurationReducer<T>(
    widgetType: WidgetType,
    initialState: T
): Reducer<T, WidgetSetSharedConfigAction<T>> {
    return (
        state: T = initialState,
        action: WidgetSetSharedConfigAction<T>
    ) => {
        if (
            !action.payload ||
            !action.payload.configDelta ||
            action.payload!.widgetType !== widgetType
        ) {
            return state;
        }

        if (action.type === WidgetActionType.WIDGET_SET_SHARED_CONFIG) {
            return { ...state, ...action.payload!.configDelta };
        }
        return state;
    };
}
